// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digital-stamp-main-view {
    background-color: #ECF0E5;
    padding: 16px;
    margin-bottom: 16px
  }
  .stamp-row-direction {
    display: flex;
    flex-direction: row
  }
  .margin-bottom{
    margin-bottom: 16px
  }
  .margin-bottom-top{
    margin-bottom: 16px;
    margin-top: 16px
  }
  .stamp-remove-button{
    justify-content: flex-end;
     display: flex;
    cursor: pointer
  }
  .stamp-field-space-between{
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    justify-content: space-between
  }
  .stamp-scroll-height{
    height: 700px; 
    overflow-y: scroll;
     overflow-x: hidden;
     padding: 3px;
     
  }
  .stamp-dotted-border{
    border-style: dashed;
     border-width: 1px; 
     border-color: #8E8E8E;
      margin: 24px 0px
  }
  .stamp-test-space{
    justify-content: space-between;display: flex
  }
  .text-transform-capitalise{
    text-transform: capitalize !important
  }
  .stamp-scroll-height::-webkit-scrollbar {
    width: 3px;
}
.toast-message{
  margin-bottom: 0rem;
}
.text-wrap{
  white-space: nowrap;
}
.loader-style{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
  z-index: 999;
  height: 100%;
  overflow:hidden
}
.qty-left-space{
  margin-left: 10px;
}
  `, "",{"version":3,"sources":["webpack://./src/Components/Common/DigitalStampOrderPopup/DigitalStampPopup.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb;EACF;EACA;IACE,aAAa;IACb;EACF;EACA;IACE;EACF;EACA;IACE,mBAAmB;IACnB;EACF;EACA;IACE,yBAAyB;KACxB,aAAa;IACd;EACF;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;EACF;EACA;IACE,aAAa;IACb,kBAAkB;KACjB,kBAAkB;KAClB,YAAY;;EAEf;EACA;IACE,oBAAoB;KACnB,iBAAiB;KACjB,qBAAqB;MACpB;EACJ;EACA;IACE,8BAA8B,CAAC;EACjC;EACA;IACE;EACF;EACA;IACE,UAAU;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ;AACF;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".digital-stamp-main-view {\n    background-color: #ECF0E5;\n    padding: 16px;\n    margin-bottom: 16px\n  }\n  .stamp-row-direction {\n    display: flex;\n    flex-direction: row\n  }\n  .margin-bottom{\n    margin-bottom: 16px\n  }\n  .margin-bottom-top{\n    margin-bottom: 16px;\n    margin-top: 16px\n  }\n  .stamp-remove-button{\n    justify-content: flex-end;\n     display: flex;\n    cursor: pointer\n  }\n  .stamp-field-space-between{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 16px;\n    justify-content: space-between\n  }\n  .stamp-scroll-height{\n    height: 700px; \n    overflow-y: scroll;\n     overflow-x: hidden;\n     padding: 3px;\n     \n  }\n  .stamp-dotted-border{\n    border-style: dashed;\n     border-width: 1px; \n     border-color: #8E8E8E;\n      margin: 24px 0px\n  }\n  .stamp-test-space{\n    justify-content: space-between;display: flex\n  }\n  .text-transform-capitalise{\n    text-transform: capitalize !important\n  }\n  .stamp-scroll-height::-webkit-scrollbar {\n    width: 3px;\n}\n.toast-message{\n  margin-bottom: 0rem;\n}\n.text-wrap{\n  white-space: nowrap;\n}\n.loader-style{\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.5;\n  z-index: 999;\n  height: 100%;\n  overflow:hidden\n}\n.qty-left-space{\n  margin-left: 10px;\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
